<template>
  <div id="app" :class="isContainer()">
    <Header v-if="isHideHeader()" />
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import Header from "./components/Header";

var Tawk_API = Tawk_API || {},
  Tawk_LoadStart = new Date();

export default {
  name: "App",
  components: { Header },
  data: function () {
    return {
      autenticado: { status: false, _id: "" },
    };
  },
  methods: {
    retornaSite() {
      return this.$site;
    },
    isContainer() {
      var classTexto =
        this.$route.name == "view" ||
        this.$route.name == "view2" ||
        this.$route.name == "view3" ||
        this.$route.name == "transmit" ||
        this.$site == "7live"
          ? "container-fluid"
          : "container";

      if (this.$site == "Weddbets") {
        classTexto = "container-fluid";
      }

      classTexto += " " + (this.isHideHeader() ? "appHeader" : "");

      classTexto += " " + (this.$site == "7live" ? "noMarginTop" : "");

      classTexto +=
        " " +
        (this.$site == "7live" &&
        (this.$route.name == "view" ||
          this.$route.name == "view2" ||
          this.$route.name == "view3")
          ? "noPadding"
          : "");

      return classTexto;
    },
    isAdmin: function () {
      return (
        this.$sessao.usuario &&
        (this.$sessao.usuario.tipoUsuario == "Administrador" ||
          this.$sessao.usuario.tipoUsuario == "Administrador Site")
      );
    },
    isEscondeChat: function () {
      return (
        this.$sessao.usuario &&
        (this.$sessao.usuario.tipoUsuario == "Administrador" ||
          this.$sessao.usuario.tipoUsuario == "Administrador Site" ||
          this.$sessao.usuario.tipoUsuario == "Apresentador")
      );
    },
    isHideHeader() {
      /*if(this.$route.name == null){
        return false;
      }*/

      return (
        this.$route.name !== "view" &&
        this.$route.name !== "view2" &&
        this.$route.name !== "view3" &&
        this.$route.name !== "transmit" &&
        this.$route.name !== "sofascore" &&
        this.$route.name !== "recuperar-senha" &&
        this.$route.name !== "login" &&
        this.$route.name !== "cadastro"
      );
    },
    chatTank() {
      let scriptTank = document.createElement("script");
      scriptTank.setAttribute("type", "text/javascript");
      scriptTank.setAttribute(
        "src",
        "https://embed.tawk.to/60637625f7ce1827093586cb/1f228b15d"
      );
      scriptTank.setAttribute("async", true);
      scriptTank.setAttribute("charset", "UTF-8");
      scriptTank.setAttribute("crossorigin", "*");
      document.head.appendChild(scriptTank);

      console.log(Tawk_LoadStart);
    },
    chatWbot() {
      /*
      let scriptWbot = document.createElement("script");
      scriptWbot.setAttribute("type", "text/javascript");
      scriptWbot.setAttribute("src", "https://wbot.chat/index.js");
      scriptWbot.setAttribute("async", true);
      scriptWbot.setAttribute('token','daaeb5b142a176638178c4a6109cb849');
      document.head.appendChild(scriptWbot);
      */
      let scriptJivo = document.createElement("script");
      scriptJivo.setAttribute("src", "//code.jivosite.com/widget/6C1auLy6iE");
      scriptJivo.setAttribute("async", true);
      document.head.appendChild(scriptJivo);
    },
  },
  mounted() {
    var thisCall = this;

    try {
      localStorage.setItem("debug", "");
    } catch (e) {
      console.log(e);
    }

    try {
      var darkMode = localStorage.getItem("darkMode", "false");

      if (darkMode == "true") {
        document.body.className += " body-dark";
      }
    } catch (e) {
      console.log(e);
    }

    if (this.$site == "Stream1x2") {
      document.body.className += " siteStream1x2";
    } else if (
      this.$site == "7live" &&
      this.$route.name == "home" &&
      this.$route.name == "agenda" &&
      this.$route.name == "meus-dados"
    ) {
      document.body.className += " site7live";
    }

    if (
      (this.$route.name == "home" || this.$route.name == "login") &&
      this.$site == "Stream1x2"
    ) {
      let script1 = document.createElement("script");
      script1.setAttribute("type", "text/javascript");
      script1.setAttribute("src", "/assets/js/chat-stream.js");
      script1.setAttribute("async", true);
      document.head.appendChild(script1);

      let script2 = document.createElement("script");
      script2.setAttribute("type", "text/javascript");
      script2.setAttribute(
        "src",
        "https://d335luupugsy2.cloudfront.net/js/loader-scripts/694bf8c2-1824-41f4-9c53-a563029a1855-loader.js"
      );
      script2.setAttribute("async", true);
      document.head.appendChild(script2);
    }

    var indieKeySorteio = localStorage.getItem("ckd");

    if (indieKeySorteio !== null) {
      setTimeout(async function () {
        //* Carrega os dados
        const apiRequest = await api.get(
          "/sessao/" + encodeURIComponent(indieKeySorteio)
        );

        //* Atualiza o cache local
        if (apiRequest.data.itens.length > 0) {
          localStorage.setItem(
            "ckdCch",
            JSON.stringify(apiRequest.data.itens[0])
          );
        } else {
          localStorage.removeItem("ckd");
          localStorage.removeItem("ckdCch");

          if (thisCall.$route.name !== "login") {
            this.$router.go({ name: "login" });
          }
        }
      }, 3000);

      //* Verifica se esta na pagina de login
      if (this.$route.name == "login") {
        this.$router.push({ name: "home" });
      }

      if (
        this.$route.name !== "sofascore" &&
        this.$route.name !== "view" &&
        this.$route.name !== "view2" &&
        this.$route.name !== "view3" &&
        this.$route.name !== "transmit" &&
        this.$route.name !== "eventos" &&
        this.$route.name !== "usuarios" &&
        this.$route.name !== "sessoes" &&
        this.$route.name !== "meus-dados"
      ) {
        if (this.$sitePrincipal == "Weddbets") {
          let scriptJivo = document.createElement("script");
          scriptJivo.setAttribute(
            "src",
            "//code.jivosite.com/widget/dI315sCDOQ"
          );

          scriptJivo.setAttribute("async", true);
          document.head.appendChild(scriptJivo);
        } else if (this.$site == "7live" && !this.isEscondeChat()) {
          let scriptJivo = document.createElement("script");
          scriptJivo.setAttribute(
            "src",
            "//code.jivosite.com/widget/Anzebp6DmL"
          );
          scriptJivo.setAttribute("async", true);
          document.head.appendChild(scriptJivo);
        } else if (this.$sitePrincipal == "Bll") {
          //this.chatTank();
          this.chatWbot();
        } else if (this.$site == "Stream1x2") {
          let scriptJivo = document.createElement("script");
          scriptJivo.setAttribute(
            "src",
            "//code.jivosite.com/widget/kRZ4TKBriT"
          );
          scriptJivo.setAttribute("async", true);
          document.head.appendChild(scriptJivo);
        }
      }

      let scriptFlash = document.createElement("script");
      scriptFlash.setAttribute("src", "/assets/js/utils.js");
      scriptFlash.setAttribute("async", true);
      document.head.appendChild(scriptFlash);

      //* Define que o usuario esta autenticado
      this.$set(this.autenticado, "status", true);
      this.$set(this.autenticado, "key", indieKeySorteio);
    } else {
      //* Verifica se esta na pagina de login
      if (
        this.$route.name !== "login" &&
        this.$route.name !== "recuperar-senha" &&
        this.$route.name !== "cadastro" &&
        this.$route.name !== "front-promocao"
      ) {
        this.$router.push({ name: "login" });
      }

      if (this.$route.name == "login" && this.$site == "Weddbets") {
        let scriptJivo = document.createElement("script");
        scriptJivo.setAttribute("src", "//code.jivosite.com/widget/dI315sCDOQ");
        scriptJivo.setAttribute("async", true);
        document.head.appendChild(scriptJivo);
      }

      if (this.$route.name == "login" && this.$site == "Stream1x2") {
        let scriptJivo = document.createElement("script");
        scriptJivo.setAttribute("src", "//code.jivosite.com/widget/kRZ4TKBriT");
        scriptJivo.setAttribute("async", true);
        document.head.appendChild(scriptJivo);
      }

      if (this.$route.name == "login" && this.$site == "7live") {
        let scriptJivo = document.createElement("script");
        scriptJivo.setAttribute("src", "//code.jivosite.com/widget/Anzebp6DmL");
        scriptJivo.setAttribute("async", true);
        document.head.appendChild(scriptJivo);
      }

      if (this.$route.name == "login" && this.$site == "Bll") {
        //this.chatTank();
        this.chatWbot();
      }
    }
  },
};
</script>

<style>
.site7live {
  font-family: "Oswald", sans-serif !important;
}

.appHeader {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  margin-bottom: 20px;
}

.noMarginTop {
  margin-top: 0px !important;
}

.noPadding {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.siteStream1x2 {
  background-color: #f5f5f5;
}

.prevent-select {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

.cursor-pointer {
  cursor: pointer;
}

.body-dark {
  color-scheme: dark !important;
  background-color: #181a1b !important;
  border-color: #736b5e !important;
  color: #e8e6e3 !important;
}

.body-dark .modal-content {
  color-scheme: dark !important;
  background-color: #181a1b !important;
  border-color: #736b5e !important;
  color: #e8e6e3 !important;
}

.body-dark .list-group-item {
  background-color: #181a1b !important;
  color: #e8e6e3 !important;
  border-color: #736b5e !important;
}

.body-dark .tituloJogos {
  color: #e8e6e3 !important;
}
</style>
